import { createModelRequest } from 'api/Exec/api';
import { ModelApiName } from 'api/Exec/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message, notification } from 'antd';
import { useState } from 'react';

const useAddDockerImage = () => {
  const [ isCreating, setIsCreating ] = useState<boolean>(false);

  const addDockerImage = async (ecrImageId: string, modelApiName: ModelApiName, description?: string) => {
    setIsCreating(true);

    return createModelRequest(ecrImageId, modelApiName, description)
      .then(({ data }) => {
        message.success('Docker image was added');
        return data;
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setIsCreating(false);
      });
  };

  return { isCreating, addDockerImage };
};

export default useAddDockerImage;
